<template>
	<input type="check" class="check" v-model="valueC" @input="update"/>
</template>

<script>
export default {
	props: {
		value: {type: [String, Number], required: true}
	},
	data() {
		return {
			valueC: this.value
		}
	},
	methods: {
		update() {
			this.$emit("input", this.valueC);
		}
	}
};
</script>

<style lang="scss" scoped>
.check {
	outline: none;
	appearance: none;
}
</style>
